import React from "react";
import { VStack, SimpleGrid } from "@chakra-ui/react";
import WalletAsset from "components/WalletAsset";
import HoneyIcon from "components/HoneyIcon";
import useTranslate from "hooks/useTranslate";
import { formatEtherBalance } from "utils/numberUtils";
import useBear from "hooks/useBear";

const BearStatsContainer = () => {
  const translate = useTranslate();
  const { vestingStats, honeyConsumed } = useBear();

  return (
    <VStack w="full" spacing="3">
      <SimpleGrid columns={2} w="full" gap="3">
        <WalletAsset
          icon={HoneyIcon}
          title={translate("bearStats:lockedHoney")}
          value={
            vestingStats?.remaining &&
            formatEtherBalance(vestingStats?.remaining)
          }
          color="dark.500"
          bg="bright.300"
        />
        <WalletAsset
          icon={HoneyIcon}
          title={translate("bearStats:honeyEaten")}
          value={honeyConsumed && formatEtherBalance(honeyConsumed)}
          color="dark.500"
          bg="bright.300"
        />
      </SimpleGrid>
    </VStack>
  );
};

export default BearStatsContainer;
